export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            品牌故事
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            关于我们
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="rounded-2xl bg-background-100 p-8 md:p-10">
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              6080新视觉影院创立于对电影艺术的无限热爱。我们相信每个人都应该有机会免费欣赏到世界各地的优秀影视作品。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              平台汇聚了超过30000部电影与电视剧资源，涵盖动作、喜剧、科幻、悬疑、爱情、动漫等全类型题材。从好莱坞巨制到国产佳片，从热门剧集到小众文艺，我们用心打造一个全面、便捷、流畅的免费观影平台。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              我们的技术团队不断优化播放引擎与CDN加速网络，确保每一位用户都能享受到秒开不缓冲的流畅观影体验。内容团队每日精心筛选优质影片，保证片源丰富、更新及时。无论是追求视觉震撼的影迷，还是喜欢慢慢品味的文艺爱好者，都能在6080新视觉影院找到属于自己的光影世界。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-6 border-t border-background-200">
              {[
                { value: '30,000+', label: '影片资源' },
                { value: '99.9%', label: '播放成功率' },
                { value: '500万+', label: '月活用户' },
                { value: '7×24', label: '内容更新' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}